import React from 'react';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const InternetConnectionError = () => <ErrorPage
  titleTextId="noInternet.title"
  title="No Connection"
  type="network"
  showButton
  onButtonClick={ () => { history.push('/'); window.location.reload(); } }
>
  <LocalisedMessage id="noInternet.content" />
</ErrorPage>;

export default InternetConnectionError;
